import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Divider,
  Autocomplete,
  FormHelperText,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import UserPurchasesValidationSchema from ".././Validations/BannerValidation";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import {
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
  BUTTON_STYLES,
  FORM_STYLES,
} from "../../styles/componentStyles";
import FilterBar from "../Reusable/FilterBar";
import BookList from "../BookList";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
function AddUserPuchases({ open, onClose, userList, setRefreshList }) {
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [books, setBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOrderEditable, setIsOrderEditable] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText("order_M4NUALXBC12YZ");
    setCopied(true);

    setTimeout(() => setCopied(false), 1500); // hide after 1.5 sec
  };
  // UserList data through update the state.
  useEffect(() => {
    if (!Array.isArray(userList) || userList.length === 0) return;

    const user = userList[0];

    setUniversityId(user.universityId || "");
    setCourseId(user.courseId || "");
    setRegulationId(user.regulationId || "");
    setSemesterId(user.semesterId || "");
  }, [userList]);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      userId: userList[0]?.id || "",
      bookIds: [],
      orderId: "order_M4NUALXBC12YZ",
      purchaseDate: "",
      expiryDate: "",
      active: "true",
    },

    validationSchema:
      UserPurchasesValidationSchema.UserPurchasesValidationSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      try {
        let response;

        response = await api.post("/api/userDetails/userPurchases", values);
        console.log(response);

        // Show success toast
        toast.success(`User Purchased books added successfully!`, {
          position: "top-right",
          autoClose: 2000,
        });
        // onSuccess(response.data.data);
        resetForm();
        onClose();
        //  Trigger refresh on parent table
        setRefreshList((prev) => prev + 1);
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });

  useEffect(() => {
    setBooks([]);
    if (
      universityId === "" &&
      courseId === "" &&
      regulationId === "" &&
      semesterId === ""
    )
      return;

    setIsLoading(true);

    api
      .get("/api/v1/allBooks", {
        params: {
          universityId: universityId,
          courseId: courseId,
          regulationId: regulationId,
          semesterId: semesterId,
        },
      })
      .then((res) => setBooks(res.data.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [universityId, courseId, regulationId, semesterId]);

  //  Automatically calculate expiryDate when purchaseDate changes
  useEffect(() => {
    if (formik.values.purchaseDate) {
      const purchaseDate = new Date(formik.values.purchaseDate);
      const expiryDate = new Date(purchaseDate);

      // Example: Add 1 year (you can change this to months/days)
      expiryDate.setMonth(expiryDate.getMonth() + 6);

      // Convert to yyyy-mm-dd format for input
      const formattedDate = expiryDate.toISOString().split("T")[0];

      // Only update if different (to prevent re-renders)
      if (formik.values.expiryDate !== formattedDate) {
        formik.setFieldValue("expiryDate", formattedDate);
      }
    }
  }, [formik.values.purchaseDate]);
  const memoizedBooks = useMemo(() => books, [books]);

  const getMinExpiryDate = (purchaseDate) => {
    if (!purchaseDate) return "";
    const date = new Date(purchaseDate);
    date.setMonth(date.getMonth() + 6);
    return date.toISOString().split("T")[0];
  };

  const PurchasesFile = "PurchasedUsers";
  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {"Add User Purchases"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              size="small"
              label="User Id"
              name="userId"
              value={formik.values.userId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.userId && Boolean(formik.errors.userId)}
              helperText={formik.touched.userId && formik.errors.userId}
              {...TEXT_FIELD_STYLES.standard}
              required
              sx={{
                mb: 2,
                ...TEXT_FIELD_STYLES.standard?.sx,
              }}
            />

            <FilterBar
              universityId={universityId}
              courseId={courseId}
              semesterId={semesterId}
              regulationId={regulationId}
              setUniversityId={setUniversityId}
              setCourseId={setCourseId}
              setSemesterId={setSemesterId}
              setRegulationId={setRegulationId}
              PurchasesFile={PurchasesFile}
            />
            <Box sx={FORM_STYLES.row}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  key={`${universityId}-${courseId}-${regulationId}-${semesterId}`}
                  size="small"
                  multiple
                  options={books}
                  name="bookIds"
                  disabled={isLoading}
                  loading={isLoading}
                  loadingText="Loading books..."
                  getOptionLabel={(option) => `${option.id} ${option.title}`}
                  value={books.filter((book) =>
                    formik.values.bookIds.includes(book.id)
                  )}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "bookIds",
                      newValue.map((book) => book.id)
                    );
                  }}
                  onBlur={() => formik.setFieldTouched("bookIds", true)}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        label={`${option.id} ${option.title}`}
                        color="primary"
                        variant="outlined"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      {...TEXT_FIELD_STYLES.standard}
                      label="Select Books"
                      placeholder="Choose one or more books"
                      error={
                        formik.touched.bookIds && Boolean(formik.errors.bookIds)
                      }
                      helperText={
                        formik.touched.bookIds && formik.errors.bookIds
                      }
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoading && (
                              <CircularProgress size={20} sx={{ mr: 2 }} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  sx={{
                    backgroundColor: "background.paper",
                    borderRadius: 2,
                    "& .MuiChip-root": { m: 0.3 },
                  }}
                />

                {/* {formik.touched.bookIds && formik.errors.bookIds && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.bookIds}
                  </FormHelperText>
                )} */}
              </FormControl>
            </Box>

            <Box sx={FORM_STYLES.row}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  size="small"
                  label="Order Id"
                  disabled={!isOrderEditable}
                  name="orderId"
                  value={formik.values.orderId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.orderId && Boolean(formik.errors.orderId)
                  }
                  helperText={formik.touched.orderId && formik.errors.orderId}
                  {...TEXT_FIELD_STYLES.standard}
                  sx={{
                    ...TEXT_FIELD_STYLES.standard.sx,
                    ...FORM_STYLES.field.sx,
                    width: "90%",
                  }}
                />
                <Tooltip title="Edit Order ID">
                  <EditIcon
                    onClick={() => setIsOrderEditable(true)}
                    sx={{
                      color: "#17479e",
                      cursor: "pointer",
                      padding: "6px",
                      marginTop: "10px",
                      borderRadius: "50%",
                      transition: "0.2s",
                      "&:hover": {
                        backgroundColor: "rgba(23, 71, 158, 0.1)",
                      },
                    }}
                  />
                </Tooltip>
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <Typography sx={{ fontSize: "13px", color: "gray" }}>
                  Suggested order_id: " order_M4NUALXBC12YZ "
                </Typography>

                <ContentCopyIcon
                  sx={{
                    fontSize: 16,
                    cursor: "pointer",
                    color: "#17479e",
                    "&:hover": { color: "#0d2f6b" },
                  }}
                  onClick={handleCopy}
                />
                {copied && (
                  <Typography sx={{ fontSize: "12px", color: "green" }}>
                    Copied!
                  </Typography>
                )}
              </Box>
              <TextField
                size="small"
                label="Purchase Date"
                name="purchaseDate"
                type="date"
                value={formik.values.purchaseDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.purchaseDate &&
                  Boolean(formik.errors.purchaseDate)
                }
                helperText={
                  formik.touched.purchaseDate && formik.errors.purchaseDate
                }
                InputLabelProps={{ shrink: true }}
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />

              <TextField
                size="small"
                label="Expiry Date"
                name="expiryDate"
                type="date"
                value={formik.values.expiryDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                inputProps={{
                  min: getMinExpiryDate(formik.values.purchaseDate),
                }}
                error={
                  formik.touched.expiryDate && Boolean(formik.errors.expiryDate)
                }
                helperText={
                  formik.touched.expiryDate && formik.errors.expiryDate
                }
                InputLabelProps={{ shrink: true }}
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box>
            <Box sx={FORM_STYLES.row}>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
                size="small"
              >
                <InputLabel>Active</InputLabel>
                <Select
                  label="Active"
                  name="active"
                  value={formik.values.active}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.active && Boolean(formik.errors.active)}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
                {formik.touched.active && formik.errors.active && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.active}
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={FORM_STYLES.actions}
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
              Cancel
            </Button>
            <Button type="submit" {...BUTTON_STYLES.primary}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AddUserPuchases;
